export const TABLE_PAGE_INIT = '1';
export const TABLE_PAGE_SIZE = '10';
export const ATTENDANCE = 'ATTENDANCE';

export const DatePattern = {
  DATE: 'YYYY-MM-DD',
  DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
  TIMESTAMP: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
  MONTH_DATE: 'MM-DD',
  UTC_DATE: 'YYYY-MM-DD[T]HH:mm:ss',
};

export const generateUuid = () => {
  let username = localStorage.getItem('username');
  if (!username) {
    username = window.crypto.randomUUID();
    localStorage.setItem('username', username);
  }
  return username;
};
